<button
  (mousedown)="$event.preventDefault()"
  (throttledClick)="!isDisabled && !isLoading && handleClick.emit($event)"
  [ngClass]="{disabled: isDisabled, loading: isLoading}"
  [throttleTime]="1000"
  class="button primary-button w-full bg-palo-verde rounded-full border border-[#1E282A] border-px box-border px-[1.2rem] whitespace-nowrap flex flex-row items-center justify-center {{this.type}}"
  [class.bg-white]="isLoading"
  [class.disabled]="isDisabled"
  [class.opacity-40]="isDisabled"
  preventMultipleClick
>
  <div
    *ngIf="!isLoading; else loader"
    class="button-content font-poppins text-white w-full truncate"
  >
    <ng-content></ng-content>
  </div>
  <ng-template #loader>
    <mat-spinner
      class="button-loader"
      mode="indeterminate"
      [diameter]="20"
    >
    </mat-spinner>
  </ng-template>
  <div [id]="buttonId" class="overlay"></div>
</button>
